import styled from 'styled-components';
import { ToastContainer } from 'react-toastify';
import { theme } from '@jadwalh/ui';

export const LayoutWrapper = styled.div`
  display: flex;
  direction: rtl;
  flex-direction: column;
  height: 100%;
  min-height: calc(100dvh - 56px);

  &:lang(en) {
    direction: ltr;
  }
  @media (min-width: 768px) {
    flex-direction: row;
    width: 100%;
    position: relative;
  }
`;

export const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  background-color: ${theme.colours.lightGray2};
  width: calc(100% - 208px);
  position: relative;
  
  /* Keep sidebar width accounted for on all screen sizes above mobile */
  @media (min-width: 768px) {
    width: calc(100% - 208px);
  }
  
  @media (max-width: 767px) {
    width: 100%;
  }

  @media (min-width: 768px) {
    border-top-left-radius: 20px;
  }
  @media (max-width: 767.5px) {
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
  }

  main {
    height: 100%;
    margin: ${theme.space_size};
    @media (max-width: 767px) {
      padding-bottom: 25px;
      margin: 0;
    }
    & > div {
      width: 100%;
      display: flex;
      flex-grow: 1;
      margin: 0 auto;
    }
    &::-webkit-scrollbar {
      width: 1px;
    }
  }
`;

export const ToastContainerWrapper = styled(ToastContainer)`
  position: unset;
`;
